<template>
  <div>
    <v-card>
      <v-card-text>

        <v-row>
          <v-col lg="4">
            <v-text-field
              placeholder="Search patient..."
              v-model="patientName"
              type="text"
              dense
              class="mt-4"
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>Start Date</label>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="start_date"
                  outlined
                  dense
                  readonly
                  persistent-hint
                  prepend-inner-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="start_date"
                no-title
                @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col lg="4">
            <label>End Date</label>
            <v-menu
              ref="menu_end"
              v-model="menu_end"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="end_date"
                  outlined
                  dense
                  readonly
                  persistent-hint
                  prepend-inner-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="end_date"
                no-title
                @input="menu_end = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="form-btn" @click="exportData">
          <v-icon left>mdi-chevron-right-circle-outline</v-icon>Export
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="presumptiveDataHandler"
      :loading="loading"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      :page.sync="page"
      item-key="id"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <export-list :data="presumptiveDataHandler" />
        </v-toolbar>
      </template>

      <template v-slot:header="{ props: { headers } }">
        <thead class="header">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="header--text"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>{{ item.unique_number }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.township.name }}</td>
          <td>{{ item.age }}</td>
          <td v-if="item.sex == 1">Male</td>
          <td v-else>Female</td>
          <td>
            <div>
              <v-btn
                @click="$router.push(`/presumptive-detail/${item.id}`)"
                icon
                color="orange darken-1"
                class="mr-2 white--text"
                depressed
              >
                <v-icon>mdi-apps-box</v-icon>
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination
        color="purple accent-4"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import exportList from "./exportList.vue";
import moment from 'moment'

export default {
  props: {
    township_id: {
      type: String,
    },
    components: {
      exportList,
    },
    presumptiveData: {
      type: Array,
    },
  },
  components: {},
  data: () => ({
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    item: {},
    dialog: false,
    patientName: null,
    start_date: null,
    end_date: null,
    headers: [
      { text: "No", value: "no" },
      { text: "Code", value: "unique_number" },
      { text: "Name", value: "name" },
      { text: "Township", value: "township" },
      { text: "Age", value: "age" },
      { text: "Sex", value: "sex" },
      { text: "Actions", value: "actions" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("Admin", ["admin"]),
    presumptiveDataHandler() {
      if (this.patientName) {
        let presumptiveData = this.presumptiveData.filter((item) => {
          return item.name
            .toLowerCase()
            .includes(this.patientName.toLowerCase());
        });
        return presumptiveData;
      }
      return this.presumptiveData;
    },
  },
  methods: {
    exportData(){
      let data = {
        township_id:this.admin.township.id,
      }
      if(this.start_date && this.end_date) {
        data.start_date = moment(this.start_date).format('YYYY-MM-DD') 
        data.end_date =  moment(this.end_date).format('YYYY-MM-DD') 
      }
      this.$store.dispatch("Presumptive/getExport", data);
    }
  },
};
</script>

<style scoped></style>
